module.exports = __webpack_public_path__ + "static/media/select-arrow-icon.20ce900e.svg";